import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByCategory'
})
export class groupByCategoryPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value){
      return value.reduce(function(rv, x) {
        let index=rv.findIndex(e=>e.category==x.categoryName);
        if(index>-1){
          rv[index].elements.push(x)
        }else{
          rv.push({category:x.categoryName,elements:[x]})
        }
        return rv;
      }, []);     
    }
    return null;
  }

}
